import { render, staticRenderFns } from "./user_menu_profile_item.vue?vue&type=template&id=6dbc4cfc"
import script from "./user_menu_profile_item.vue?vue&type=script&lang=js"
export * from "./user_menu_profile_item.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports